import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e770064"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { class: "place-logo-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "ion-margin-vertical" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "info-sentence"
}
const _hoisted_9 = {
  key: 2,
  class: "info-sentence"
}
const _hoisted_10 = {
  key: 3,
  class: "info-sentence"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 4,
  class: "info-sentence"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "info-sentence" }
const _hoisted_15 = {
  key: 5,
  class: "info-sentence"
}
const _hoisted_16 = { class: "ion-margin-top" }
const _hoisted_17 = {
  key: 0,
  class: "info-sentence"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "ion-margin-top" }
const _hoisted_20 = { style: {"font-size":"24px"} }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["src"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_star_rating = _resolveComponent("star-rating")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_section_header = _resolveComponent("section-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, {
    class: _normalizeClass({ 'disabled': $setup.place.permClosed })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        title: $setup.loading ? '...' : $setup.place['名稱'],
        parentPath: $setup.parentPath || '/places'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_buttons, { slot: "end" }, {
            default: _withCtx(() => [
              ($setup.userLoggedIn && $setup.place.likedByUser)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateUserLikedPlace($setup.place, 'remove')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.heart,
                        color: "danger"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.userLoggedIn && !$setup.place.likedByUser)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateUserLikedPlace($setup.place, 'add')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.heartOutline,
                        color: "danger"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_button, {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.sharePlace($setup.place)), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    icon: $setup.shareSocialOutline
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "parentPath"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : _createCommentVNode("", true),
          (!$setup.loading && $setup.place.id)
            ? (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "12",
                        class: "ion-text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, { class: "no-border-card" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    "size-xs": "12",
                                    "size-md": "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("img", {
                                          width: "100%",
                                          class: "main-image",
                                          src: $setup.place.mainImgLink
                                        }, null, 8, _hoisted_3)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, {
                                    "size-xs": "12",
                                    "size-md": "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_content, { class: "ion-padding-top ion-no-padding" }, {
                                        default: _withCtx(() => [
                                          ($setup.place.avgSMPRating)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                                                _createVNode(_component_star_rating, {
                                                  rating: $setup.place.avgSMPRating
                                                }, null, 8, ["rating"]),
                                                _hoisted_5,
                                                _createTextVNode(" " + _toDisplayString($setup.place.avgSMPRating) + " / 5 (" + _toDisplayString($setup.place.avgSMPRatingUserTotal) + ") ", 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_6, [
                                            _createVNode(_component_ion_badge, {
                                              color: $setup.getTypeColor($setup.place['種類'])
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString($setup.place['種類']), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["color"]),
                                            _hoisted_7,
                                            ($setup.place.permClosed)
                                              ? (_openBlock(), _createBlock(_component_ion_chip, {
                                                  key: 0,
                                                  outline: "",
                                                  color: "danger"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.t('permClosed')), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          ($setup.place.userLikes > 0)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.place.userLikes) + " 人收藏此地點 ", 1))
                                            : _createCommentVNode("", true),
                                          ($setup.place['成立年份'])
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                                _createElementVNode("b", null, _toDisplayString($setup.t('yearFounded')) + _toDisplayString($setup.place['成立年份']), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          ($setup.place['電郵'])
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                                _createVNode(_component_ion_icon, {
                                                  class: "icon-md",
                                                  icon: $setup.mail
                                                }, null, 8, ["icon"]),
                                                _createTextVNode(" " + _toDisplayString($setup.t('email')), 1),
                                                _createElementVNode("a", {
                                                  href: `mailto:${$setup.place['電郵']}`
                                                }, _toDisplayString($setup.place['電郵']), 9, _hoisted_11)
                                              ]))
                                            : _createCommentVNode("", true),
                                          ($setup.place['電話'])
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                                _createVNode(_component_ion_icon, {
                                                  class: "icon-md",
                                                  icon: $setup.call
                                                }, null, 8, ["icon"]),
                                                _createTextVNode(" " + _toDisplayString($setup.t('phone')), 1),
                                                _createElementVNode("a", {
                                                  href: `tel:${$setup.place['電話']}`
                                                }, _toDisplayString($setup.place['電話']), 9, _hoisted_13)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("p", _hoisted_14, [
                                            _createVNode(_component_ion_icon, {
                                              class: "icon-md",
                                              icon: $setup.location
                                            }, null, 8, ["icon"]),
                                            _createTextVNode(" " + _toDisplayString($setup.t('address')) + _toDisplayString($setup.place['地址']), 1)
                                          ]),
                                          _createElementVNode("p", null, [
                                            _createVNode(_component_ion_badge, { color: "primary" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString($setup.place["大區"]), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode("  "),
                                            _createVNode(_component_ion_badge, { color: "tertiary" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString($setup.place["地區"]), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode("  "),
                                            _createVNode(_component_ion_badge, { color: "medium" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString($setup.place["細區"]), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          ($setup.place['營業時間'])
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                                                _createVNode(_component_ion_icon, {
                                                  class: "icon-md",
                                                  icon: $setup.time
                                                }, null, 8, ["icon"]),
                                                _createTextVNode(" " + _toDisplayString($setup.t('openingHours')) + _toDisplayString($setup.place['營業時間']), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_16, [
                                            ($setup.place.distance)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_17, " 距離：" + _toDisplayString($setup.place.distance), 1))
                                              : _createCommentVNode("", true),
                                            ($setup.place['latLong'])
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                  _createVNode(_component_ion_button, {
                                                    shape: "round",
                                                    color: "tertiary",
                                                    href: `http://maps.apple.com/maps?q=${$setup.place['latLong']}`
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.t('openPlaceMap')) + " ", 1),
                                                      _createVNode(_component_ion_icon, {
                                                        slot: "end",
                                                        icon: $setup.compassOutline
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["href"])
                                                ]))
                                              : _createCommentVNode("", true),
                                            ($setup.userLoggedIn)
                                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                                  key: 2,
                                                  class: "ion-margin-top",
                                                  shape: "round",
                                                  color: "primary",
                                                  "router-link": {
                        name: 'FeedbackPage',
                        state: { passedPlace: JSON.stringify($setup.place) }
                      }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      slot: "start",
                                                      icon: $setup.chatbubbleEllipsesOutline
                                                    }, null, 8, ["icon"]),
                                                    _createTextVNode(" " + _toDisplayString($setup.t('sendFeedback')), 1)
                                                  ]),
                                                  _: 1
                                                }, 8, ["router-link"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, { size: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item_divider, { class: "ion-no-padding" }),
                                      _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_component_section_header, {
                                          icon: $setup.statsChart,
                                          title: $setup.t('statistics')
                                        }, null, 8, ["icon", "title"]),
                                        _createVNode(_component_ion_segment, {
                                          class: "ion-margin-bottom",
                                          color: "tertiary",
                                          modelValue: $setup.showingStatSection,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.showingStatSection) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createVNode(_component_ion_segment_button, { value: "google" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_label, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Google")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_icon, { icon: $setup.logoGoogle }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 512), [
                                              [_vShow, $setup.place.gmRating]
                                            ]),
                                            _withDirectives(_createVNode(_component_ion_segment_button, { value: "facebook" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_label, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("FB")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_icon, { icon: $setup.logoFacebook }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 512), [
                                              [_vShow, $setup.place.fbLikes]
                                            ]),
                                            _withDirectives(_createVNode(_component_ion_segment_button, { value: "instagram" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_label, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("IG")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_icon, { icon: $setup.logoInstagram }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 512), [
                                              [_vShow, $setup.place.igFollowers]
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"]),
                                        _withDirectives(_createElementVNode("div", null, [
                                          _createVNode(_component_ion_item, {
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openBrowser($setup.place['Facebook']))),
                                            button: "",
                                            detail: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                icon: $setup.logoFacebook,
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createVNode(_component_ion_label, { class: "link-text" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(decodeURI($setup.place['Facebook'])), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                icon: $setup.thumbsUpOutline,
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.numberWithCommas($setup.place.fbLikes)) + " " + _toDisplayString($setup.t('likes')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          ($setup.place.fbFollowers)
                                            ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    icon: $setup.people,
                                                    slot: "start"
                                                  }, null, 8, ["icon"]),
                                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.numberWithCommas($setup.place.fbFollowers)) + " " + _toDisplayString($setup.t('followers')), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _withDirectives(_createVNode(_component_ion_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                icon: $setup.calendarOutline,
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.t('pageFoundingDate')) + _toDisplayString($setup.formatDateString($setup.place.fbFoundingDate)), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 512), [
                                            [_vShow, $setup.place.fbFoundingDate]
                                          ]),
                                          _withDirectives(_createVNode(_component_ion_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                color: "warning",
                                                icon: $setup.star,
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.t('rating')) + " " + _toDisplayString($setup.place.fbRating) + " / 5 ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 512), [
                                            [_vShow, $setup.place.fbRating]
                                          ])
                                        ], 512), [
                                          [_vShow, $setup.showingStatSection == 'facebook']
                                        ]),
                                        _withDirectives(_createElementVNode("div", null, [
                                          _createVNode(_component_ion_item, {
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openBrowser($setup.place['Instagram']))),
                                            button: "",
                                            detail: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                icon: $setup.logoInstagram,
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createVNode(_component_ion_label, { class: "link-text" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(decodeURI($setup.place['Instagram'])), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                icon: $setup.imagesOutline,
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.numberWithCommas($setup.place.igMediacount)) + " " + _toDisplayString($setup.t('posts')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                icon: $setup.people,
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.numberWithCommas($setup.place.igFollowers)) + " " + _toDisplayString($setup.t('followers')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ], 512), [
                                          [_vShow, $setup.showingStatSection == 'instagram']
                                        ]),
                                        _withDirectives(_createElementVNode("div", null, [
                                          _createVNode(_component_ion_item, { lines: "none" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                color: "warning",
                                                icon: $setup.star,
                                                slot: "start"
                                              }, null, 8, ["icon"]),
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.t('rating')) + " ", 1),
                                                  _createElementVNode("span", _hoisted_20, [
                                                    _createElementVNode("b", null, _toDisplayString($setup.place.gmRating), 1)
                                                  ]),
                                                  _createTextVNode(" / 5 (" + _toDisplayString($setup.place.gmUserRatingsTotal) + ") ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          ($setup.place.gmReviewsPerScore)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['5', '4', '3', '2', '1'], (rating) => {
                                                  return _createVNode(_component_ion_item, {
                                                    lines: "none",
                                                    key: rating
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_note, {
                                                        slot: "start",
                                                        style: {"padding":"0","margin-inline-end":"16px"}
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(rating), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_ion_progress_bar, {
                                                        style: {"margin":"0"},
                                                        slot: "end",
                                                        value: $setup.place.gmReviewsPerScore[rating] / $setup.place.gmUserRatingsTotal
                                                      }, null, 8, ["value"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                }), 64))
                                              ]))
                                            : _createCommentVNode("", true),
                                          (!$setup.place.fetchedDetails)
                                            ? (_openBlock(), _createBlock(_component_ion_col, {
                                                key: 1,
                                                size: "12",
                                                class: "ion-text-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_spinner)
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_ion_list, { key: 2 }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.place.gmReviews, (review, idx) => {
                                                    return (_openBlock(), _createBlock(_component_ion_item, { key: idx }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_chip, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_ion_avatar, null, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("img", {
                                                                      src: review.profile_photo_url,
                                                                      referrerpolicy: "no-referrer"
                                                                    }, null, 8, _hoisted_22)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024),
                                                                _createVNode(_component_ion_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(review.author_name), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            (review.text)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                                  _withDirectives(_createElementVNode("p", null, _toDisplayString(review.text), 513), [
                                                                    [_vShow, review.showFullText]
                                                                  ]),
                                                                  _withDirectives(_createElementVNode("p", null, [
                                                                    _createTextVNode(_toDisplayString(review.text.substr(0, 250)) + " ", 1),
                                                                    _withDirectives(_createElementVNode("span", null, [
                                                                      _createTextVNode(" ..."),
                                                                      _hoisted_24,
                                                                      _createElementVNode("a", {
                                                                        onClick: ($event: any) => (review.showFullText = true)
                                                                      }, "More", 8, _hoisted_25)
                                                                    ], 512), [
                                                                      [_vShow, review.text.length > 250]
                                                                    ])
                                                                  ], 512), [
                                                                    [_vShow, !review.showFullText]
                                                                  ])
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            _createVNode(_component_ion_row, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_ion_col, { size: "8" }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("p", null, [
                                                                      _createVNode(_component_star_rating, {
                                                                        rating: review.rating
                                                                      }, null, 8, ["rating"]),
                                                                      _createTextVNode(" " + _toDisplayString(review.rating) + " / 5 ", 1)
                                                                    ])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024),
                                                                _createVNode(_component_ion_col, {
                                                                  class: "ion-text-right",
                                                                  size: "4"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("small", null, _toDisplayString($setup.getRelativeDate(review.time * 1000)), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              }))
                                        ], 512), [
                                          [_vShow, $setup.showingStatSection == 'google']
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}